const MONTHS_GENITIVE = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
] as const;

function startOfLocalDay(date: Date): number {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}

function formatClock(date: Date): string {
    return date.toLocaleTimeString('ru', { hour: '2-digit', minute: '2-digit' });
}

/**
 * Подпись даты/времени для списка диалогов:
 * «Сегодня, 14:27» / «Вчера, 14:27» / «15 июля, 14:27» / «15 июля 2024, 14:27».
 */
export function formatSessionUpdatedAtLabel(date: Date, now: Date = new Date()): string {
    const time = formatClock(date);
    const dayDiff = Math.round((startOfLocalDay(now) - startOfLocalDay(date)) / 86_400_000);

    if (dayDiff === 0) {
        return `Сегодня, ${time}`;
    }

    if (dayDiff === 1) {
        return `Вчера, ${time}`;
    }

    const day = date.getDate();
    const month = MONTHS_GENITIVE[date.getMonth()];
    const yearSuffix = date.getFullYear() !== now.getFullYear() ? ` ${date.getFullYear()}` : '';

    return `${day} ${month}${yearSuffix}, ${time}`;
}
